<template>
    <div class="removable">
        <input
            :value="value"
            @input="$emit( 'input', $event.target.value )"
            :class="{ 'is-invalid' : invalid }"
            class="form-control m-input m-input--air removable__input"
            type="text"
            maxlength="255">
        <div class="removable__icon d-flex justify-content-center align-items-center"
             @click="trigger">
            <span>×</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'index',
            'value',
            'invalid',
        ],

        methods: {
            trigger: function() {
                bus.$emit('on-remove', this.index)
            },
        },
    };
</script>

<style scoped lang="scss">
    .removable {
        position: relative;
        flex-grow: 1;

        .removable__icon {
            position: absolute;
            right: 6px;
            top: 50%;
            z-index: 2;
            width: 1.4rem;
            height: 1.4rem;
            padding: .4rem;
            color: #aaa;
            font-size: 1.3rem;
            font-weight: bold;
            text-align: center;
            background: #dfe2ea;
            border-radius: 50%;
            cursor: pointer;
            transform: translateY( -50% );

            span {
                position: relative;
                top: -0.1rem;
            }
        }
    }
</style>
